import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-gray-400 py-12 mt-24" data-id="element-1">
      <div className="max-w-4xl mx-auto px-6 text-center text-sm font-sans space-y-4" data-id="element-2">
        <p data-id="element-3">
          This is an advertorial and not an actual news article, blog, or
          consumer protection update.
        </p>
        <p data-id="element-4">
          The statements made on this website have not been evaluated by the
          Food and Drug Administration. This product is not intended to
          diagnose, treat, cure, or prevent any disease.
        </p>
        <p className="pt-4 border-t border-gray-800" data-id="element-5">
          &copy; {new Date().getFullYear()} ClearGuard Pro. All rights reserved.
        </p>
      </div>
    </footer>;
}